import React from "react";
import { Box, Paper, Typography, Chip, Divider } from "@mui/material";
import CopyButton from "../utils/UI/CopyButton";
import { useTheme } from "@mui/material";
import { safeJsonParse } from "../utils/utils";
import JsonSection from "../utils/UI/JsonSection";
type Props = {
  logs: any;
};

const getStatusColor = (status: number) => {
  if (status >= 200 && status < 300) return "#22c55e";
  if (status >= 400 && status < 500) return "#f59e0b";
  if (status >= 500) return "#ef4444";
  return "#9ca3af";
};

const formatDateTime = (iso: string) => {
  const d = new Date(iso);

  return {
    date: d.toLocaleDateString("ru-RU"),
    time: d.toLocaleTimeString("ru-RU", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }),
  };
};

const LogsMobileComponent: React.FC<Props> = ({ logs }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        overflow: "auto",
        maxHeight: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      {logs.map((el: any) => {
        const { date, time } = formatDateTime(el.ts);
        const statusColor = getStatusColor(el.status);

        return (
          <Paper
            key={el.id}
            elevation={0}
            sx={{
              p: 1.5,
              borderRadius: 2,
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              gap: 0.5,
            }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box display="flex" alignItems="center" gap={1}>
                <Chip
                  label={el.status}
                  size="small"
                  sx={{
                    backgroundColor: statusColor + "15",
                    color: statusColor,
                    border: "1px solid " + statusColor + "40",
                    fontWeight: 700,
                    height: 20,
                    fontSize: 11,
                  }}
                />

                <Typography fontSize={11} sx={{ opacity: 0.6 }}>
                  {el.duration_ms} ms
                </Typography>
              </Box>

              <Typography fontSize={10} sx={{ opacity: 0.5 }}>
                {date} {time}
              </Typography>
            </Box>
            <Divider
              sx={{
                borderColor: "rgba(255,255,255,0.08)",
              }}
            />

            <Box
              sx={{
                background: "#38bff875",
                borderRadius: 1,
                p: 1,
                border: "1px solid rgba(255,255,255,0.06)",
              }}
            >
              <Typography
                fontSize={11}
                fontWeight={600}
                sx={{ wordBreak: "break-all" }}
              >
                {el.id}
              </Typography>
            </Box>

            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography fontSize={11}>request_id</Typography>

              <Box display="flex" gap={1}>
                <Typography fontSize={11}>{el.request_id}</Typography>

                <CopyButton value={el.request_id} />
              </Box>
            </Box>

            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography fontSize={11}>transaction_id</Typography>

              <Box display="flex" gap={1}>
                <Typography fontSize={11}>{el.transaction_id}</Typography>

                <CopyButton value={el.transaction_id} />
              </Box>
            </Box>

            {/* url */}
            <Box
              sx={{
                background: "rgba(255,255,255,0.02)",
                borderRadius: 1,
                px: 1,
                py: 0.5,
              }}
            >
              <Typography
                fontSize={11}
                sx={{
                  wordBreak: "break-all",
                  fontFamily: "monospace",
                  opacity: 0.7,
                }}
              >
                {el.url ?? el.path}
              </Typography>
            </Box>
            <Box
              sx={{
                mt: 0.5,
                borderRadius: 1,
                border: "1px solid rgba(255,255,255,0.06)",
                overflow: "hidden",
              }}
            >
              <JsonSection
                title="Request body"
                data={safeJsonParse(el.request_body)}
              />

              <JsonSection
                title="Response body"
                data={safeJsonParse(el.response_body)}
              />

              <JsonSection title="Req. Headers" data={el.request_headers} />

              <JsonSection title="Res. Headers" data={el.response_headers} />
            </Box>
            <Box textAlign="right" mt={0.5}>
              <Typography fontSize={10}>
                {date} {time}
              </Typography>
            </Box>
          </Paper>
        );
      })}
    </Box>
  );
};

export default LogsMobileComponent;
